"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var THEME_BASE_1 = __importStar(require("../../THEME_BASE"));
var ColorVariants = Object.keys(THEME_BASE_1.default.colors[THEME_BASE_1.COLOR_SCHEME_LIGHT].variant);
var shades = ['light', 'lighter', 'lightest', 'dark', 'darker', 'darkest'];
var shadesMap = (_a = {},
    _a[THEME_BASE_1.COLOR_SCHEME_LIGHT] = {
        light: -1,
        lighter: -3,
        lightest: -5,
        dark: 1,
        darker: 3,
        darkest: 4,
    },
    _a[THEME_BASE_1.COLOR_SCHEME_DARK] = {
        light: 1,
        lighter: 3,
        lightest: 4,
        dark: -1,
        darker: -3,
        darkest: -5,
    },
    _a);
var variantColors = function (colorScheme, colors, primaryShade) {
    if (![THEME_BASE_1.COLOR_SCHEME_DARK, THEME_BASE_1.COLOR_SCHEME_LIGHT].includes(colorScheme)) {
        throw new Error("Requires \"".concat(THEME_BASE_1.COLOR_SCHEME_DARK, "\" or \"").concat(THEME_BASE_1.COLOR_SCHEME_LIGHT, "\" color scheme option."));
    }
    var variantBaseColors = Object.fromEntries(ColorVariants.map(function (colorVariant) { return [colorVariant, colors[colorVariant][primaryShade]]; }));
    var variantColorShades = Object.fromEntries(shades.map(function (shade) { return ([shade, {}]); }));
    var schemeShadesMap = shadesMap[colorScheme];
    ColorVariants.forEach(function (colorVariant) {
        shades.forEach(function (shade) {
            variantColorShades[shade][colorVariant] = colors[colorVariant][primaryShade + schemeShadesMap[shade]];
        });
    });
    return __assign(__assign({}, variantBaseColors), variantColorShades);
};
exports.default = variantColors;
